import { useRef, useState } from "react";
import { api, errMsg } from "../api";
import { notifyCompanyChanged, useCompany } from "./CompanyLogo";
import { Btn, Notice } from "./ui";
import { useEntities } from "../entity";

/** Configurações › Foto de perfil (PF): imagem que substitui as iniciais no canto superior direito. PNG, JPEG ou WebP, até 300 KB. */
const MAX = 300 * 1024;
export function ProfilePhoto({ realm }: { realm: "pf" | "pj" }) {
  const { current } = useEntities(); const entityId = current?.id;
  const { info, logoUrl } = useCompany(realm, entityId);
  const [msg, setMsg] = useState<{ kind: "ok" | "error"; text: string } | null>(null); const file = useRef<HTMLInputElement>(null);
  if (!entityId) return null;
  const canWrite = current.permission === "total";
  function pick(ev: React.ChangeEvent<HTMLInputElement>) {
    const f = ev.target.files?.[0]; ev.target.value = ""; if (!f) return;
    if (!/^image\/(png|jpeg|webp)$/.test(f.type)) return setMsg({ kind: "error", text: "Use uma imagem PNG, JPEG ou WebP." });
    if (f.size > MAX) return setMsg({ kind: "error", text: "A imagem deve ter no máximo 300 KB. Reduza o tamanho e tente novamente." });
    const r = new FileReader();
    r.onload = async () => {
      try { await api("PUT", `/api/${realm}/company/logo`, { entityId, data: String(r.result).split(",")[1] ?? "" }); setMsg({ kind: "ok", text: "Foto atualizada." }); notifyCompanyChanged(); } catch (e) { setMsg({ kind: "error", text: errMsg(e) }); }
    };
    r.readAsDataURL(f);
  }
  async function remove() { try { await api("PUT", `/api/${realm}/company/logo`, { entityId, data: null }); setMsg({ kind: "ok", text: "Foto removida." }); notifyCompanyChanged(); } catch (e) { setMsg({ kind: "error", text: errMsg(e) }); } }
  return (
    <div className="card" style={{ maxWidth: 560, marginBottom: 16 }} data-profile-photo>
      <h3 style={{ fontSize: 16, marginBottom: 6 }}>Foto de perfil</h3>
      <p className="muted" style={{ marginTop: 0 }}>A imagem aparece no lugar das suas iniciais, no canto superior direito.</p>
      {msg && <Notice kind={msg.kind}>{msg.text}</Notice>}
      <div style={{ display: "flex", gap: 14, alignItems: "center", flexWrap: "wrap" }}>
        <div style={{ width: 72, height: 72, borderRadius: "50%", overflow: "hidden", border: "1px solid var(--line, #c8ced6)", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--surface-2)" }}>
          {logoUrl ? <img src={logoUrl} alt="Foto atual" style={{ width: "100%", height: "100%", objectFit: "cover" }} data-photo-preview /> : <span className="muted small">Sem foto</span>}
        </div>
        {canWrite && <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <input ref={file} type="file" accept="image/png,image/jpeg,image/webp" onChange={pick} style={{ display: "none" }} data-photo-file />
          <Btn variant="ghost" onClick={() => file.current?.click()}>{info?.hasLogo ? "Trocar foto" : "Enviar foto"}</Btn>
          {info?.hasLogo && <Btn variant="ghost" onClick={remove}>Remover</Btn>}
          <span className="muted small" style={{ alignSelf: "center" }}>PNG, JPEG ou WebP, até 300 KB.</span>
        </div>}
      </div>
    </div>);
}
